import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

type NavbarUnloggedEvents = {
    'navbar-unlogged:reset-selected-host': undefined;
};

export const eventBus = createEventBus<NavbarUnloggedEvents>();
